import { useRouter } from "next/router";
import { useEffect } from "react";

export default function Home() {
  const router = useRouter();

  useEffect(() => {
    router.push("https://christiaan-shop.myalbumdev.com");
  }, [router]);

  return null;
}
